import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const defaultAccount = { accountId: '', grpId: '', gender: '' }

const readAccountFromStorage = () => {
  if (typeof window === 'undefined') {
    return defaultAccount
  }

  return {
    accountId: window.localStorage.getItem('account_ID') || '',
    grpId: window.localStorage.getItem('grp_ID') || '',
    gender: window.localStorage.getItem('gender') || '',
  }
}

const AccountContext = createContext(defaultAccount)

export const AccountProvider = ({ children }) => {
  const [account, setAccount] = useState(() => readAccountFromStorage())

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined
    }
    const handleStorage = (event) => {
      if (!event.key || ['account_ID', 'grp_ID', 'gender'].includes(event.key)) {
        setAccount(readAccountFromStorage())
      }
    }

    window.addEventListener('storage', handleStorage)
    return () => window.removeEventListener('storage', handleStorage)
  }, [])

  const value = useMemo(() => account, [account])
  return <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
}

AccountProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useAccount = () => useContext(AccountContext)
export default AccountContext
